import { memo } from 'react';
import { cn } from '@cyphex/ui';
import type { MediaClient } from '../media/contract';
import { columnsFor } from '../media/tileOrder';
import type { TileView } from '../media/tilePlan';
import { VideoTile } from './VideoTile';

export interface VideoGridProps {
  tiles: readonly TileView[];
  client: MediaClient;
  pinnedId: string | null;
  onPin: (participantId: string | null) => void;
}

/**
 * Never more than `MEDIA_LIMITS.MAX_VISIBLE_TILES` tiles exist in the DOM —
 * the plan guarantees it, and the pager handles the rest.
 */
const BASIS: Record<number, string> = {
  1: 'basis-full',
  2: 'basis-[calc(50%-4px)]',
  3: 'basis-[calc(33.333%-5.34px)]',
};

const ROW_HEIGHT: Record<number, string> = {
  1: 'h-full',
  2: 'h-[calc(50%-4px)]',
  3: 'h-[calc(33.333%-5.34px)]',
};

export const VideoGrid = memo(function VideoGrid({ tiles, client, pinnedId, onPin }: VideoGridProps) {
  const columns = columnsFor(tiles.length);
  const rows = Math.min(3, Math.max(1, Math.ceil(tiles.length / columns)));

  return (
    <div className="flex h-full min-h-0 w-full flex-wrap content-start gap-2">
      {tiles.map((tile) => (
        <VideoTile
          key={tile.participant.id}
          tile={tile}
          client={client}
          pinned={pinnedId === tile.participant.id}
          onPin={onPin}
          className={cn('min-w-0 grow', BASIS[columns], ROW_HEIGHT[rows])}
        />
      ))}
    </div>
  );
});
